/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import brandConfig from "../config/brands.config.json";
import settingsConfig from "../config/settings.config.json";
import { StorageModule } from "@vlinder-web/storage-module-react";
import { GET_BAND } from "../graphql/getBand.query";
import { GET_INFO } from "../graphql/getInfo.query";
const is = require("is_js");

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IInfoMethods extends IPluginMethodMap {
  getInfo(args: any): Promise<any>;
}

export class InfoService implements IAgentPlugin {
  readonly methods: IInfoMethods;

  constructor() {
    this.methods = {
      getInfo: this.getInfo.bind(this),
    };
  }

  async getInfo(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    try {
      if (client) {
        const res = await client.query({
          query: GET_INFO,
          variables: {
            filter: {
              costumeID: args?.costumeID,
            },
          },
          fetchPolicy: "network-only",
        });
        if (res?.data?.getBox) {
          console.log(res?.data?.getBox);
          return {
            city: res?.data?.getBox?.address?.city,
            address: res?.data?.getBox?.address?.addressLine1,
            availableTimings: res?.data?.getBox?.availableTime,
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }
      throw err;
    }
  }
}
